// extracted by mini-css-extract-plugin
export var gif = "_lk-0";